import { dispatchError, dispatchLoading, dispatchSuccess } from '../utils';
import { GET_NOTIFIKASI, API_TIMEOUT } from '../utils/constant';

import axios from 'axios';

export const GET_LIST_NOTIFIKASI = 'GET_LIST_NOTIFIKASI';

export const getNotifikasi = () => {
  return (dispatch) => {
    dispatchLoading(dispatch, GET_LIST_NOTIFIKASI);

    axios({
      method: 'get',
      url: GET_NOTIFIKASI,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          dispatchError(dispatch, GET_LIST_NOTIFIKASI, 'error');
        } else {
          //BERHASIL

          dispatchSuccess(
            dispatch,
            GET_LIST_NOTIFIKASI,
            response.data.data ? response.data.data : []
          );
        }
      })
      .catch((error) => {
        // ERROR
        dispatchError(dispatch, GET_LIST_NOTIFIKASI, error);
        alert(error);
      });
  };
};
